import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { HttpClient } from "@angular/common/http";
import { UserModel } from "src/app/shared/models/users/user-model";
import { CompanyRegistrationModel } from "src/app/shared/models/company-registration/company-registration.model";
import { Observable } from "rxjs";
import { MazayaTermsAndConditionsResponseModel } from "src/app/shared/models/terms-and-conditions/terms-and-conditions";

@Injectable({
  providedIn: "root",
})
export class LoginService {
  private deleteUser=`${environment.serverUrl}/users`;
  private hayyakoffers = '../../../assets/files/hayyakoffers.json';
private mazayaResource=`${environment.serverUrl}/mazayaTermsAndConditions`
  constructor(private http: HttpClient) { }

  login(payload: { username: string; password: string }) {
    const url = `${environment.serverUrl}/login`;
    
    return this.http.post<any>(url, {
      username: payload.username,
      loz: payload.password,
    });
  }
  getBuyerTermsAndCondition(): Observable<MazayaTermsAndConditionsResponseModel> {
    const url = `${this.mazayaResource}/getTermsConditionsBuyer`;
    return this.http.get<MazayaTermsAndConditionsResponseModel>(url);
  }
  register(user: UserModel) {
    user.loz = user.password;
    user.confirmLoz = user.confirmPassword;
    const url = `${environment.serverUrl}/registration`;
    return this.http.post<any>(url, user);
  }

  saveTradeLicence(file: File): Observable<any> {
    const formData = new FormData();
    formData.append("image", file);
    return this.http.post<any>(
      `${environment.serverUrl}/document/upload`,
      formData
    );
  }

    saveImage(file: File): Observable<any> {
    const formData = new FormData();
    formData.append("file", file);
    return this.http.post<any>(
      `${environment.nodeServerUrl1}/upload`,
      formData
    );
  }
    uploadDocument(file: File): Observable<any> {
    const formData = new FormData();
    formData.append("file", file);
    return this.http.post<any>(
      `${environment.nodeServerUrl1}/upload`,
      formData
    );
  }
  refresh(payload: string) {
    const url = `${environment.serverUrl}/refresh`;
    return this.http.post<any>(url, { refreshToken: payload });
  }
  logout(): Observable<any> {
    const url = `${environment.serverUrl}/logout`;
    return this.http.post<any>(url, null);
  }
  sendMessage(firstName:string,lastName:string,email:string,message:string) {
    const url = `${environment.serverUrl}/sendmessage`;
    return this.http.post<any>(`${url}?FirstName=${firstName}&LastName=${lastName}&MailId=${email}&Message=${message}`, null);
  }
  userDelete(): Observable<any> {
    return this.http.delete<any>(`${environment.nodeServerUrl1}/users`);
  }
  
  getHayyakOffersData(): Observable<any> {
    return this.http.get<any>(this.hayyakoffers);
  }
}
